import { Route } from '@angular/router';
import { NoAccessPageComponent } from './no-access/no-access-page.component';
import { noRoleGuard } from './auth/no-role.guard';
import { runInSerialGuard } from '@lyceo/shared/util';
import { forcedLoginGuard } from '@lyceo/shared/auth/feature-main';
import { roleGuard } from './auth/role.guard';

const allowedRoles: string[] = [
  'ROLE_SKOLEO_LYCEO_ALFRED_ADMIN',
  'ROLE_SKOLEO_LYCEO_ALFRED_MANAGER',
  'ROLE_SKOLEO_LYCEO_ALFRED_CONTENT_MANAGER',
];

export const appRoutes: Route[] = [
  {
    path: 'geen-toegang',
    component: NoAccessPageComponent,
    canActivate: [noRoleGuard(['/'], allowedRoles)],
  },
  {
    path: 'overzicht',
    canActivate: [
      runInSerialGuard([
        forcedLoginGuard(),
        roleGuard(['/geen-toegang'], allowedRoles),
      ]),
    ],
    loadChildren: () =>
      import('./user-overview/user-overview.routes').then(
        (m) => m.userOverviewRoutes,
      ),
  },
  {
    path: 'vragenlijsten',
    canActivate: [
      runInSerialGuard([
        forcedLoginGuard(),
        roleGuard(['/geen-toegang'], allowedRoles),
      ]),
    ],
    loadChildren: () =>
      import('./questionnaires/questionnaires.routes').then(
        (m) => m.questionnairesRoutes,
      ),
  },
  {
    path: 'mobile-preview',
    loadChildren: () =>
      import('./mobile-preview/mobile-preview.routes').then(
        (m) => m.mobilePreviewRoutes,
      ),
  },
  {
    path: '**',
    redirectTo: '/overzicht',
  },
];
